import React from "react";
import { ListGroup, Row, Col, Image, Button } from "react-bootstrap";
import { API_BASE_URL } from "../../Config";
import { formatCurrency } from "../../utils";

function CartList({ cart, handleQuantityChange, handleRemoveFromCart }) {
  return (
    <ListGroup variant="flush">
      {cart.map((item) => (
        <ListGroup.Item key={item.product.id}>
          <Row className="cart-product pb-3">
            <Col md={2} className="text-center">
              <Image
                src={
                  API_BASE_URL +
                  (item.product.image ? item.product.image : "/media/products/no-image.png")
                }
                alt={item.product.product_name}
                fluid
              />
            </Col>

            <Col md={2} className="pt-3 pt-md-4 pt-lg-2 text-center">
              <select
                className="form-select"
                value={item.quantityInCart}
                onChange={(event) => handleQuantityChange(event, item.product.id)}
              >
                {[...Array(10).keys()].map((value) => (
                  <option key={value + 1} value={value + 1}>
                    {value + 1}
                  </option>
                ))}
              </select>
            </Col>

            <Col md={4} className="pt-3 pt-md-4 pt-lg-1 text-left">
              {item.product.product_name}
            </Col>

            <Col md={2} className="pt-2 pt-md-4 pt-lg-2 text-center text-md-end">
              <h4>
                {formatCurrency(item.product.real_price * (1 - item.product.discount / 100))}
              </h4>
            </Col>

            <Col md={2} className="pt-2 pt-md-4 pt-lg-2 text-sm-center text-md-end">
              <Button
                className="trash"
                type="button"
                aria-label={`Remover ${item.product.product_name}`}
                onClick={() => handleRemoveFromCart(item.product.id)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                </svg>
              </Button>
            </Col>
          </Row>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
}

export default CartList;
